import { AxiosInterceptor } from 'axiosConfig'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material'
import { ErrorBoundary } from 'react-error-boundary'
import { SnackbarProvider } from 'notistack'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import store from './store'
import { theme } from './theme/theme'
import { OopsError } from './components/OopsError'
import { GlobalRoutes } from './routes/routes.config'
import { AppServiceProvider } from './services/main/AppService'

function App({ msalInstance }: { msalInstance: PublicClientApplication }) {
  return (
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <AxiosInterceptor>
          <Router>
            <SnackbarProvider>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                  <CssBaseline />
                  <ErrorBoundary FallbackComponent={OopsError}>
                    <AppServiceProvider>
                      <GlobalRoutes />
                    </AppServiceProvider>
                  </ErrorBoundary>
                </ThemeProvider>
              </StyledEngineProvider>
            </SnackbarProvider>
          </Router>
        </AxiosInterceptor>
      </Provider>
    </MsalProvider>
  )
}

export default App
